import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row shopcontainer",
  style: {"display":"flex"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-6 col-md-12 col-xs-12\"><div class=\"imagecard\"><img alt=\"good proxies\" src=\"https://cdn.proxyscrape.com/img/gp2.gif\"></div></div><div class=\"col-lg-6 col-md-12 col-xs-12\"><div class=\"textcard\"><h2>The best premium proxies, at scale</h2><br><ul><li>Unlimited bandwidth</li><li>Unlimited concurrent connections</li><li>Up to 50 000 HTTP/s and Socks4/5 datacenter proxies</li><li>Whitelist up to 3 IPs with the datacenter proxies (upgrades available)</li><li>Amazing shared datacenter proxies that always work</li></ul><a class=\"pricing-btn blue-btn mt-4\" href=\"#pricing\">PRICING</a></div></div><div class=\"col-12\" style=\"margin-bottom:30px;\"></div>", 3)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12",
  style: {"margin-bottom":"30px"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-12 col-xs-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "imagecard" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "uptime monitoring",
      src: "https://cdn.proxyscrape.com/img/uptime_monitoring.png"
    })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12",
  style: {"margin-bottom":"30px"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-title mt-4" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Already convinced?"),
    /*#__PURE__*/_createElementVNode("a", {
      class: "pricing-btn blue-btn mt-4",
      href: "#pricing"
    }, "VIEW PRICING")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12",
  style: {"margin-bottom":"30px"}
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12",
  style: {"margin-bottom":"30px"}
}, null, -1)

import CompareUs from '@/components/services/premium/shop-container/compare-us.vue';
import SneakpeakDashbaord from '@/components/services/premium/shop-container/sneakpeak-dashbaord.vue';
import UptimeMonitoring from '@/components/services/premium/shop-container/uptime-monitoring.vue';
import WhyPremium from '@/components/services/premium/shop-container/why-premium.vue';
import ServiceSupport from '@/components/shared/ServiceSupport.vue';
import QuickRecap from '@/components/services/premium/shop-container/quick-recap.vue';
import PageHead from '@/components/shared/PageHead.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const head = {
  title: 'ProxyScrape Premium',
  subtitle: 'Fast static datacenter proxies',
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHead, { head: head }),
    _hoisted_2,
    _createVNode(WhyPremium),
    _hoisted_5,
    _hoisted_6,
    _createVNode(UptimeMonitoring),
    _hoisted_7,
    _createVNode(CompareUs),
    _hoisted_8,
    _createVNode(SneakpeakDashbaord),
    _hoisted_9,
    _createVNode(ServiceSupport),
    _hoisted_10,
    _createVNode(QuickRecap)
  ]))
}
}

})